import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-vender-messge-dialog',
  templateUrl: './vender-messge-dialog.component.html',
  styleUrls: ['./vender-messge-dialog.component.css']
})
export class VenderMessgeDialogComponent implements OnInit {

  @Input() openDelayLeadPoppup:any;
  @Input() notApprovePaymentList:any;
  @Input() approvePaymentList:any;
  @Output() onCloseModalPopup : EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    this.notApprovePaymentList = this.notApprovePaymentList
    this.approvePaymentList = this.approvePaymentList
  }

  ngAfterViewInit(){
    console.log("new value!!!!")
    this.notApprovePaymentList = this.notApprovePaymentList
    this.approvePaymentList = this.approvePaymentList
    //for open delay lead popup
    if(this.openDelayLeadPoppup){
      setTimeout(
        function () {
          this.delayedLeads()
        }.bind(this),
        1000
      );
    }
  }

  delayedLeads() {
    $("#delayLeadsModal").modal("show");
  }

  onCloseModal(){
    this.onCloseModalPopup.emit({open:false});
    $("#delayLeadsModal").modal("hide");
    [].forEach.call(document.querySelectorAll('.modal-backdrop'), function (el) {
      el.style.visibility = 'hidden';
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/platform/finance/vendor-payment/vender-messge-dialog/vender-messge-dialog.component.ts